import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Children, useCallback, useMemo, useState, } from 'react';
import { Box, Button, MobileStepper, useTheme } from '@mui/material';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { isIOSApp } from 'utils';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { ControlledSwiper } from 'shared/components/modals/swiper/controlled';
import { Controller, EffectCards, Navigation } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import { LinearProgressWithLabel } from 'z3k-settings/components/material-utils/linear-progress-with-label';
import { StyledTypography } from 'shared/components/compare-card/ui/typography';
import 'swiper/css';
import 'swiper/css/effect-cards';
import { useBox } from 'shared/hooks/utils';
export function MobileView(props) {
    const { data, component, title, progress } = props;
    const theme = useTheme();
    const [local_step, setLocalStep] = useState(0);
    const ListData = useMemo(() => data?.map(component), [data, component]);
    const [touchPosition, setTouchPosition] = useState(null);
    const boxedTouchPosition = useBox(touchPosition);
    const onChangeSlide = useCallback(({ activeIndex }) => {
        setLocalStep(activeIndex);
    }, []);
    const handleBackStep = useCallback((event) => {
        // event.preventDefault();
        setLocalStep((value) => {
            const new_value = value - 1;
            if (new_value < 0) {
                return value;
            }
            return new_value;
        });
    }, [data?.length]);
    const handleForwardStep = useCallback((event) => {
        // event.preventDefault();
        setLocalStep((value) => {
            const new_value = value + 1;
            if (new_value > (data?.length ?? 0) - 1) {
                return value;
            }
            return new_value;
        });
    }, []);
    const handleTouchStart = useCallback((event) => {
        const touchDown = event.touches[0].clientX;
        setTouchPosition(touchDown);
    }, []);
    const handleTouchMove = useCallback((event) => {
        if (boxedTouchPosition.current === null) {
            return;
        }
        const currentTouch = event.touches[0].clientX;
        const diff = boxedTouchPosition.current - currentTouch;
        if (diff > 10) {
            handleForwardStep(event);
        }
        if (diff < -10) {
            handleBackStep(event);
        }
    }, []);
    return (_jsxs(_Fragment, { children: [title && _jsx(StyledTypography, { children: title }), _jsx(Box, { sx: {
                    overflowX: 'hidden',
                }, boxSizing: "border-box", children: _jsxs(ErrorBoundary, { children: [_jsx(Box, { px: 1, children: isIOSApp() ? (_jsx(Box, { display: "flex", gap: 2, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, style: { marginBottom: '10px', marginTop: '10px' }, children: _jsx(Box, { display: "flex", gap: 2, px: 2, children: Children.map(ListData, (child, index) => index == local_step ? child : null) }) })) : (_jsx(ControlledSwiper, { slidesPerView: 1, spaceBetween: 11, modules: [Controller, EffectCards, Navigation], effect: "cards", onSlideChange: onChangeSlide, style: { marginBottom: '10px', marginTop: '10px' }, navigation: {
                                    nextEl: '.button-next',
                                    prevEl: '.button-prev',
                                }, children: Children.map(ListData, (child, index) => {
                                    return (_jsx(SwiperSlide, { children: child }, index));
                                }) })) }), progress && (_jsx(Box, { sx: { width: '100%', padding: '2% 5% 2% 5%' }, children: _jsx(LinearProgressWithLabel, { value: progress }) })), _jsx(Box, { mt: 1, children: _jsx(MobileStepper, { sx: {
                                    bgcolor: 'background.default',
                                    width: '100%',
                                    boxSizing: 'border-box',
                                }, position: "static", variant: "dots", steps: data ? data.length : 0, activeStep: local_step, nextButton: _jsx(Button, { className: "button-next", size: "medium", sx: {
                                        color: 'primary.dark',
                                    }, disabled: local_step === (data?.length ?? 0) - 1, endIcon: theme.direction === 'rtl' ? (_jsx(KeyboardArrowLeft, {})) : (_jsx(KeyboardArrowRight, {})) }), backButton: _jsx(Button, { className: "button-prev", size: "medium", sx: {
                                        color: 'primary.main',
                                    }, disabled: local_step === 0, startIcon: theme.direction === 'rtl' ? (_jsx(KeyboardArrowRight, {})) : (_jsx(KeyboardArrowLeft, {})) }) }) })] }) })] }));
}
